import { useState, useEffect } from "react"
import { PopupType } from "../types"
import { SonometerService } from "../../services/sonometer.service"
import { Sonometer } from "sonometer/types/sonometer.model"

interface UseSonometerScreenPollingReturn {
    screen: PopupType | undefined
    loading: boolean
    error: string | null
    sonometerFromServer: Sonometer | null
}

const useSonometerScreenPolling = (
    sonometerId: string,
    interval: number = 1000
): UseSonometerScreenPollingReturn => {
    const [screen, setScreen] = useState<PopupType | undefined>(undefined)
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<string | null>(null)
    const [sonometerFromServer, setSonometerFromServer] =
        useState<Sonometer | null>(null)

    useEffect(() => {
        let isMounted = true // To prevent state updates on unmounted component

        const fetchSonometerScreen = async () => {
            try {
                setLoading(true)
                setError(null)

                const sonometerService = new SonometerService()
                const response =
                    await sonometerService.getSonometerById(sonometerId)

                //type check fix pending
                if (response) {
                    setSonometerFromServer(response)
                }

                console.log(
                    "🔍 [POLLING HOOK] Fetched sonometer screen:",
                    response.screen
                )

                if (isMounted) {
                    setScreen(response.screen)
                }
            } catch (err: any) {
                if (isMounted) {
                    setError(err.message || "Failed to fetch sonometer screen")
                }
            } finally {
                if (isMounted) {
                    setLoading(false)
                }
            }
        }

        fetchSonometerScreen() // Initial fetch

        const intervalId = setInterval(fetchSonometerScreen, interval)

        return () => {
            isMounted = false
            clearInterval(intervalId)
        }
    }, [sonometerId, interval])

    return { screen, loading, error, sonometerFromServer }
}

export default useSonometerScreenPolling
